/** Polling helper for async tasks. */
import api from "./api";

/**
 * Polls /api/tasks/{id} until status is 'done' or 'error'.
 * Tolère les 504/502/429/timeout transitoires (worker unique saturé pendant LLM call) :
 * on ignore ces erreurs et on retry au prochain tick au lieu de planter le UI.
 * @returns {Promise<{status:'done'|'error', result_id?:string, error?:string}>}
 */
export async function pollTask(taskId, { intervalMs = 2500, timeoutMs = 180000, onTick } = {}) {
  const start = Date.now();
  let consecutiveErrors = 0;
  while (Date.now() - start < timeoutMs) {
    try {
      const r = await api.get(`/tasks/${taskId}`, { timeout: 8000 });
      const t = r.data;
      consecutiveErrors = 0;
      if (onTick) onTick(t);
      if (t.status === "done" || t.status === "error") return t;
    } catch (err) {
      const status = err?.response?.status;
      // Tolère 502/503/504 (gateway saturé pendant un LLM call) et timeouts axios
      const isTransient = status === 502 || status === 503 || status === 504 || status === 429
        || err?.code === "ECONNABORTED" || err?.code === "ERR_NETWORK";
      if (!isTransient) {
        // 401, 404, 400... → vraie erreur, on remonte
        throw err;
      }
      consecutiveErrors += 1;
      // Si > 12 erreurs consécutives (≥30s sans réponse), on abandonne
      if (consecutiveErrors > 12) {
        throw new Error("Le serveur reste saturé. Réessayez dans une minute.");
      }
    }
    await new Promise((res) => setTimeout(res, intervalMs));
  }
  throw new Error("Délai dépassé pour la tâche IA");
}
